export enum OptionMenuEnum {
    Module = 1,
    SubModule,
    Screen,
    Function
}
